<template>
	<v-col>
		<v-row>
			<v-col class="d-flex">
				<v-img
					:src="require('assets/static/img/logo/fastpaytv.png')"
					alt="logo"
					contain
					width="100"
					height="100"
				/>
			</v-col>
			<v-col class="d-flex">
				<v-img
					:src="require('assets/static/img/logo/fastpaytv.png')"
					alt="logo"
					contain
					width="100"
					height="100"
				/>
			</v-col>
		</v-row>
		<v-row
			v-for="number in result.numbers"
			:key="number.playType.id"
			no-gutters
		>
			<v-col class="text-center" cols="4" align-self="center">
				<span class="pick">
					<img
						:src="imageForPlayType(number.playType)"
						width="200"
						alt="playType"
						class="pick"
					/>
				</span>
			</v-col>
			<v-col cols="8">
				<img
					v-for="(result, index) in number.digits"
					:key="index"
					:src="balls[parseInt(result, 10)]"
					height="120"
					alt="result"
					class="ball"
				/>
			</v-col>
		</v-row>
	</v-col>
</template>

<script>
import ResultField from '../../../../enumerations/ResultField.json';
import ball0 from 'assets/static/img/balls/fastpay/ball_0.png';
import ball1 from 'assets/static/img/balls/fastpay/ball_1.png';
import ball2 from 'assets/static/img/balls/fastpay/ball_2.png';
import ball3 from 'assets/static/img/balls/fastpay/ball_3.png';
import ball4 from 'assets/static/img/balls/fastpay/ball_4.png';
import ball5 from 'assets/static/img/balls/fastpay/ball_5.png';
import ball6 from 'assets/static/img/balls/fastpay/ball_6.png';
import ball7 from 'assets/static/img/balls/fastpay/ball_7.png';
import ball8 from 'assets/static/img/balls/fastpay/ball_8.png';
import ball9 from 'assets/static/img/balls/fastpay/ball_9.png';

import pick2 from 'assets/static/img/picks/fastpay/pick2.png';
import pick3 from 'assets/static/img/picks/fastpay/pick3.png';
import pick4 from 'assets/static/img/picks/fastpay/pick4.png';
import pick5 from 'assets/static/img/picks/fastpay/pick5.png';

export default {
	name: 'WinningNumbers',
	props: {
		result: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			balls: [
				ball0,
				ball1,
				ball2,
				ball3,
				ball4,
				ball5,
				ball6,
				ball7,
				ball8,
				ball9
			]
		};
	},
	mounted() {
		this.$confetti.start();
	},
	destroyed() {
		this.$confetti.stop();
	},
	methods: {
		imageForPlayType(playType) {
			switch (playType.id) {
				case ResultField.PickTwo:
					return pick2;
				case ResultField.CashThree:
					return pick3;
				case ResultField.PickFour:
					return pick4;
				case ResultField.PickFive:
					return pick5;
			}
		}
	}
};
</script>
